export default {
    news: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/news/state.js